import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { QuoteApproval } from '../core/models/quote-approval.model';
import { PaginateQuery, PaginateResult, Quote, SummaryBenefitModel, SummaryQuoteModel } from '../core';
import { catchError, Observable, of, retry, throwError } from 'rxjs';
import { PlanApiResponse } from '../core/models/plan-api-response';
import { PlanApiFilterRequest } from '../core/models/plan-api-filter-request';

@Injectable({ providedIn: 'root' })
export class QuoteService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'Quote');
  }

  quoteApproval(data: QuoteApproval) {
    return this.http.post(`${this.route()}/quoteaproval`, data);
  }

  quoteView(quoteID: string) {
    return this.http.post<Quote>(`${this.route()}/QuoteView/${quoteID}`, null);
  }

  quoteSummary(quoteID: string) {
    return this.http.get<SummaryQuoteModel>(`${this.route()}/Summary/${quoteID}`);
  }

  quotePlanBenefits(quoteID: string, planID: string) {
    return this.http.get<SummaryBenefitModel[]>(`${this.route()}/Benefits/${quoteID}/${planID}`);
  }

  getPlans(customerID: string, dependentsIDs: string[], planType: string, filter: PlanApiFilterRequest): Observable<PlanApiResponse> {
    return this.http.post<PlanApiResponse>(`${this.route()}/GetPlansForCustomer`, {
      customerID,
      DependentsIds: dependentsIDs,
      PlanType: planType,
      planFilterRequestModel: filter,
    });
  }

  updateStatus(quoteID: string, status: string) {
    return this.http.put(`${this.route()}/UpdateStatus/${quoteID}`, { status });
  }

  updateDateEnrolled(quoteID: string, dateEnrolled: string) {
    return this.http.put(`${this.route()}/UpdateDateEnrolled/${quoteID}`, { dateEnrolled });
  }

  getQuotesByPhone(phoneNumber: string) {
    return this.http.get<SummaryQuoteModel[]>(`${this.route()}/Summary/phonenumber/${phoneNumber}`);
  }

  paginateTree(data: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(this.route() + '/QuoteTree/Paginate', data).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      }),
    );
  }

  paginateDeleted(data: PaginateQuery): Observable<PaginateResult> {
    const url = `${this.route()}/Deleted/Paginate`;
    return this.http.post<PaginateResult>(url, data).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        }
        return throwError(() => error);
      }),
    );
  }

  recover(id: string): Observable<void> {
    const url = `${this.route()}/${id}/Recover`;
    return this.http.patch<void>(url, null).pipe(retry(2));
  }
}
